/**
 * Model choices offered by the automation steps that call an LLM.
 *
 * Extracted from `EvaluateStepConfig` so a second step can offer the same
 * choices without duplicating the list. Labels are product names; callers pass
 * them through `t()` at render time like any other displayed string.
 */

export interface LlmModelOption {
	value: string;
	label: string;
}

/**
 * Anthropic (Claude) models offered by the "Process with AI" step. PD-17582:
 * the current generation; the list used to offer only models the API has
 * retired (Claude Sonnet 4 and the Claude 3 family), which answer 404.
 */
export const ANTHROPIC_MODEL_OPTIONS: Array<LlmModelOption> = [
	{ value: 'claude-haiku-5-5', label: 'Claude Haiku 5.5' },
	{ value: 'claude-sonnet-5-5', label: 'Claude Sonnet 5.5' },
	{ value: 'claude-opus-5-5', label: 'Claude Opus 5.5' },
];

/** OpenAI models offered by the "Process with AI" step. */
export const OPENAI_MODEL_OPTIONS: Array<LlmModelOption> = [
	{ value: 'gpt-4o', label: 'GPT-4o' },
	{ value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
	{ value: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
	{ value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
];
